import { CommentForm } from './CommentForm';

export const CreateCommentForm = ({ onSubmit, onLoadSuggestions }) => {
  const handleSubmit = async (values, { resetForm }) => {
    await onSubmit(values);
    await resetForm({});
  };

  return (
    <CommentForm
      onSubmit={handleSubmit}
      onLoadSuggestions={onLoadSuggestions}
    />
  );
};
export const EditCommentForm = ({
  initialValues,
  onSubmit,
  onCancel,
  onLoadSuggestions,
}) => {
  return (
    <CommentForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      onCancel={onCancel}
      onLoadSuggestions={onLoadSuggestions}
      showAlwaysActions={true}
    />
  );
};
